var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-button',{attrs:{"type":_vm.buttonType,"size":"sm","loading":_vm.followLoading},on:{"click":_vm.handleFollow}},[_vm._v(_vm._s(this.isFollowing() ? 'UNFOLLOW' : 'FOLLOW')+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }